<app-text-input class="flex w-100" style="min-width: 211px;"
                [input]="searchControl"
				[disabled]="searchControl.disabled"
				[fromSearch]="true"
                [placeholder]="'Search'">
    <!--img icon-prefix class="filter-grey" src="assets/icons/search-md.svg" height="16px" alt=""/-->
    <app-icon-button icon-suffix [img]="'assets/icons/close.svg'" size="xs" color="primary" [panelClass]="'img-size-30'"
                     *ngIf="searchControl.value?.length > 0"
					 [disabled]="searchControl.disabled"
                     (click)="searchControl.reset('')"></app-icon-button>
</app-text-input>
